import { computed, ref } from 'vue';
import * as Sentry from '@sentry/vue';
import { mapGetters } from '@/store/lib/vue3helpers.js';
import { local_storage, localStorageKey } from '@/store/lib/local_storage.js';

const SNOOZE_DAYS = 30;

function isWithinSnooze(snoozed_at) {
  if (!snoozed_at) return false;
  const snoozed_until = new Date(snoozed_at);
  snoozed_until.setDate(snoozed_until.getDate() + SNOOZE_DAYS);
  return snoozed_until > new Date();
}

export default function useUpsellSnooze(option) {
  const { current_profile } = mapGetters(['current_profile']);
  const storage_key = localStorageKey(current_profile.value, option);

  function readSnoozedAt() {
    if (!storage_key) return null;
    try {
      return local_storage.get(storage_key).snoozed_at || null;
    } catch (error) {
      Sentry.captureException(error);
      return null;
    }
  }

  const snoozed_at = ref(readSnoozedAt());
  const is_snoozed = computed(() => isWithinSnooze(snoozed_at.value));

  function snooze() {
    snoozed_at.value = new Date().toISOString();
    if (!storage_key) return;
    try {
      local_storage.set(storage_key, { snoozed_at: snoozed_at.value });
    } catch (error) {
      Sentry.captureException(error);
    }
  }

  return { is_snoozed, snooze };
}
